import CaseFile from "./CaseFile";

const MEDIA = "/media/projects/slice-joint";

const data = {
    index: "002",
    client: "First We Feast",
    title: "Slice Joint",
    titleLines: ["Slice", "Joint"],
    lead: "Not a polished set pretending to be one.",
    passages: [
        "Slice Joint is a First We Feast interview series built around the visual world of a classic New York slice shop. Money Mac Media shaped the show’s visual identity from early look development through final graphics execution — grounded, familiar, and authentic.",
        "Every choice, from signage to lighting to surface texture, was aimed at making the world feel lived-in, specific, and visually recognizable. Neon signage, orange counters, menu boards, framed wall photos, booth seating, pizza boxes, and late-night storefront energy — a visual language rooted in real NYC pizzeria details, not a generic food-show look.",
    ],
    gallery: [
        {
            label: "Signage & identity",
            items: [
                { src: `${MEDIA}/title-card.webp`, caption: "Neon signage — title card", testid: "slice-title-card" },
                { src: `${MEDIA}/logo.webp`, caption: "Logo treatment", testid: "slice-logo" },
                { src: `${MEDIA}/thumb.webp`, caption: "Show key art — thumbnail", testid: "slice-thumb" },
            ],
        },
        {
            label: "The shop",
            items: [
                { src: `${MEDIA}/intro-still.webp`, caption: "Intro — pizzeria environment", testid: "slice-intro" },
                { src: `${MEDIA}/wall-of-fame.webp`, caption: "Wall of Fame — environment", testid: "slice-wall" },
            ],
        },
        {
            label: "On screen",
            items: [
                { src: `${MEDIA}/title-card-mortis.webp`, caption: "Episode title card — Jersey Sh*t", testid: "slice-mortis" },
                { src: `${MEDIA}/lower-third.webp`, caption: "Lower third", testid: "slice-lower3rd" },
                { src: `${MEDIA}/credits.webp`, caption: "Credits frame", testid: "slice-credits" },
            ],
        },
    ],
    contributions: [
        "Overall visual direction for the show package",
        "Logo treatments inspired by classic neon signage",
        "Title sequence concepts and final motion direction",
        "Lower thirds, interstitials, credits, and supporting graphics",
        "Pizzeria-inspired environments and visual references",
        "Ethical-AI look development — ethically sourced image generation, original design workflows",
        "Authenticity, brand safety, and production flexibility — balanced",
    ],
    services: [
        "Visual direction",
        "Logo treatments",
        "Title sequence",
        "Show package",
        "Lower thirds",
        "Interstitials",
        "Credits",
        "Environments",
        "Ethical-AI look development",
    ],
};

export default function SliceJoint() {
    return <CaseFile data={data} />;
}
